export default {
    list() {
        const data = (constantes?.ETAPA_OPTIONS || []).slice();
        return Promise.resolve({
            data: {
                data,
                per_page: data.length,
                total: data.length,
            },
        });
    },
    option() {
        return Promise.resolve({
            data: (constantes?.ETAPA_OPTIONS || []).slice(),
        });
    },
}
